import React from 'react';
import PageBase from '../components/PageBase';
import YoutubeVideo from '../components/YoutubeVideo';
import {Helmet} from "react-helmet";

const ZerDaDuatloia = () => {
  return (
    <PageBase title="Zer da duatloia?"
              navigation="Oñatiko Duatloi Txikia / Zer da duatloia?">
      <Helmet>
        <title>Oñatiko Dutloi Txikia Zer da duatloia</title>
        <meta name="description" content="Zer da duatloia?" />
        <meta property="og:title" content="Oñatiko Dutloi Txikia Zer da duatloia" />
        <meta property="og:description" content="Zer da duatloia?" />
        <meta property="og:url" content="http://duatloitxikia.oinatikoduatloia.com/zerdaduatloia" />
        <meta property="og:image" content="http://www.txantxiku.net/duatlon_onati/duatloi_txikia_2018/slides/IMG_2085.JPG" />
      </Helmet>
        

      <p>Duatloia bakarkako eta erresistentziako kirol mota bat da, bi kirol diziplina biltzen dituena, atletismoa eta txirrindularitza hain zuzen ere. Eta hurrengo ordenean jartzen dira praktikan: korrika, txirrindularitza eta korrika. Horrela, kategorien arabera distantzia eta zirkuitu desberdinak egongo dira.</p> 
      <p>Jarduera honen helburua, herriko gaztetxoei beste kirol bat gehiago ezagutzera ematea da. Gainera, kirol hau beraien gustukoa izanez gero, adinean aurrera egin ahala herrian duatloia zein triatloia praktikatzen jarraitzeko aukera eta taldea izango lukete, Aloña Mendi triatloi sailaren bitartez.</p>

          <YoutubeVideo
            title="Oñatiko I. Duatloi Txikia"
            videoCode="Z9g7nrtKVUg"
            width="600"
            height="400"
          />

          <YoutubeVideo
            title="2012 Oñatiko Duatloia"
            videoCode="arZ8eIg5hHM"
            width="600"
            height="400"
          />
    </PageBase>
  );
};

export default ZerDaDuatloia;



/** WEBPACK FOOTER **
 ** ./src/containers/ZerDaDuatloia.js
 **/